import React from 'react';
import { FileSearchIcon, ClipboardListIcon, ScaleIcon } from 'lucide-react';
import { Section, SectionHeading } from './shared';
// 11 — RESULTS / CASE EXPERIENCE · [Trust] [Conversion]
// No approved case studies supplied → show "How we build and manage a claim" evidence cards.
// All proof marked [VERIFY]. caseStudies pattern retained but not fabricated.
const caseStudies: {
  title: string;
  industry: string;
  challenge: string;
  solution: string;
  results: {
    metric1: {
      value: string;
      label: string;
    };
  };
}[] = [];
const evidenceCards = [{
  icon: FileSearchIcon,
  title: 'We investigate thoroughly',
  body: 'We gather medical records, incident details and factual evidence to understand the full picture of what happened and its effect on you.'
}, {
  icon: ClipboardListIcon,
  title: 'We manage the claim end to end',
  body: 'We organise reports, correspondence and documentation, keeping the process moving while you focus on recovery.'
}, {
  icon: ScaleIcon,
  title: 'We are prepared to litigate',
  body: 'Where negotiation is not enough, we are experienced in taking a claim further to protect your interests.'
}];
export function CaseExperience() {
  return <Section id="results" className="bg-paper" data-id="element-50">
      <SectionHeading eyebrow="Case experience" title="How We Build and Manage a Claim" intro="We only publish verified case studies once approved. Until then, here is how our experience shows in the way we handle every claim." data-id="element-51" />

      {caseStudies.length === 0 ? <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3" data-id="element-52">
          {evidenceCards.map(c => {
        const Icon = c.icon;
        return <div key={c.title} className="flex h-full flex-col rounded-card border border-ink/5 bg-paper p-7 shadow-card" data-id="element-53">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-btn bg-forest/8 text-forest" data-id="element-54">
                  <Icon aria-hidden="true" className="h-5 w-5" strokeWidth={1.75} data-id="element-55" />
                </span>
                <h3 className="mt-4 text-h4 font-semibold text-ink" data-id="element-56">
                  {c.title}
                </h3>
                <p className="mt-2 text-body text-slate" data-id="element-57">{c.body}</p>
              </div>;
      })}
        </div> : null}

      <p className="mt-8 max-w-2xl text-small text-slate/70" data-id="element-58">
        Past experience does not guarantee a particular outcome. Every claim
        depends on its own facts and the applicable law.
      </p>
    </Section>;
}